let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fqdHF")).then(() => parcelRequire('l6k6c'));